// extracted by css-extract-rspack-plugin
export default {"button-link":"button-link-gNWMSR","buttonLink":"button-link-gNWMSR"};